module.exports = __webpack_public_path__ + "static/img/21map4.124ba4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/04sportDesc/21map4.png
// module id = xhVZ
// module chunks = 0